<script setup>
  import { ref, onMounted } from 'vue';

  const props = defineProps({
    styleClasses: {
      type: String,
      default: null,
    },
  });

  const versionNumber = ref(null);

  function getVersionNumberFromUrl() {
    const url = window.location.toString();
    const regex = /\/(v[a-zA-Z0-9.]+)\//;
    const match = url.match(regex);
    const version = match ? match[1] : null;

    return version;
  }

  onMounted(() => {
    versionNumber.value = getVersionNumberFromUrl();
  });    
</script>

<template>
  <p v-if="versionNumber" :class="props.styleClasses">{{ versionNumber }}</p>
</template>